import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import { 
  FiHome, 
  FiDatabase, 
  FiFileText, 
  FiZap, 
  FiClock, 
  FiArchive, 
  FiSettings,
  FiShield
} from 'react-icons/fi';
import { SiWordpress } from 'react-icons/si';

const menuItems = [
  { path: '/', icon: FiHome, label: 'Dashboard' },
  { path: '/data-sources', icon: FiDatabase, label: 'Źródła Danych' },
  { path: '/templates', icon: FiFileText, label: 'Szablony' },
  { path: '/generator', icon: FiZap, label: 'Generator' },
  { path: '/scheduler', icon: FiClock, label: 'Harmonogram' },
  { path: '/history', icon: FiArchive, label: 'Historia' },
  { path: '/wordpress', icon: SiWordpress, label: 'WordPress' },
  { path: '/integrations', icon: FiSettings, label: 'Integracje' },
];

export default function Sidebar() {
  return (
    <div className="w-64 bg-gray-900 text-white flex flex-col">
      {/* Logo */}
      <div className="p-6 border-b border-gray-800">
        <h1 className="text-2xl font-bold">🤖 Social Agent</h1>
        <p className="text-gray-400 text-sm mt-1">Dashboard</p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4">
        {menuItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            end={item.path === '/'}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 mb-2 rounded-lg transition-colors ${
                isActive
                  ? 'bg-blue-600 text-white'
                  : 'text-gray-300 hover:bg-gray-800'
              }`
            }
          >
            <item.icon className="mr-3" size={20} />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>

      {/* Footer */}
      <div className="p-4 border-t border-gray-800 text-xs text-gray-500">
        <Link 
          to="/privacy" 
          className="flex items-center text-gray-400 hover:text-white transition-colors mb-3 text-sm"
        >
          <FiShield className="mr-2" size={16} />
          Polityka Prywatności
        </Link>
        <p>Social Agent v1.0.0</p>
        <p className="mt-1">© 2025</p>
      </div>
    </div>
  );
}

